import { EntityList } from "../../components/entity-management";
import { api } from "../../services/api";

const regionConfig = {
  queryKey: "search-regions",
  api: {
    getList: () => api.getRegions(),
    create: (data: { name: string }) => api.createRegion(data),
    update: (id: string, data: { id?: string; name: string }) => api.updateRegion(id, data),
    delete: (id: string) => api.deleteRegion(id),
  },
  labels: { entityName: "Region" },
};

export function RegionList() {
  return <EntityList config={regionConfig} />;
}
